import { Form, InputNumber, Table } from "antd";

const InterPhallengealJoint = ({ initial = false }) => {
  const inputStyle = {
    width: "100%",
    maxWidth: "120px",
    textAlign: "center",
  };
  const columns = [
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
    },
    {
      title: "Left Active",
      dataIndex: "left_active",
      key: "left_active",
      render: (text, record) => (
        <Form.Item
          name={
            initial
              ? ["rom", "inter_phalangeal_joint", `left_active_${record.value}`]
              : ["inter_phalangeal_joint", `left_active_${record.value}`]
          }
        >
          <InputNumber
            max={record.max}
            min={record.min}
            placeholder={`${record.min} to ${record.max}`}
            style={inputStyle}
          />
        </Form.Item>
      ),
    },
    {
      title: "Left Passive",
      dataIndex: "left_passive",
      key: "left_passive",
      render: (text, record) => (
        <Form.Item
          name={
            initial
              ? [
                  "rom",
                  "inter_phalangeal_joint",
                  `left_passive_${record.value}`,
                ]
              : ["inter_phalangeal_joint", `left_passive_${record.value}`]
          }
        >
          <InputNumber
            max={record.max}
            min={record.min}
            placeholder={`${record.min} to ${record.max}`}
            style={inputStyle}
          />
        </Form.Item>
      ),
    },
    {
      title: "Right Active",
      dataIndex: "right_active",
      key: "right_active",
      render: (text, record) => (
        <Form.Item
          name={
            initial
              ? [
                  "rom",
                  "inter_phalangeal_joint",
                  `right_active_${record.value}`,
                ]
              : ["inter_phalangeal_joint", `right_active_${record.value}`]
          }
        >
          <InputNumber
            max={record.max}
            min={record.min}
            placeholder={`${record.min} to ${record.max}`}
            style={inputStyle}
          />
        </Form.Item>
      ),
    },
    {
      title: "Right Passive",
      dataIndex: "right_passive",
      key: "right_passive",
      render: (text, record) => (
        <Form.Item
          name={
            initial
              ? [
                  "rom",
                  "inter_phalangeal_joint",
                  `right_passive_${record.value}`,
                ]
              : ["inter_phalangeal_joint", `right_passive_${record.value}`]
          }
        >
          <InputNumber
            max={record.max}
            min={record.min}
            placeholder={`${record.min} to ${record.max}`}
            style={inputStyle}
          />
        </Form.Item>
      ),
    },
  ];

  const data = [
    {
      key: "1",
      action: "Flexion",
      value: "flexion",
      max: 50,
      min: 0,
    },
    {
      key: "2",
      action: "Extension",
      value: "extension",
      max: 50,
      min: 0,
    },
  ];
  return (
    <>
      <Table columns={columns} dataSource={data} pagination={false} rowKey="key" scroll={{ x: "max-content" }}/>
    </>
  );
};

export default InterPhallengealJoint;